import React, { useState, useEffect } from 'react';
import FeedbackCard from '../FeedbackCard/FeedbackCard';
import Loading from '../../Loading/Loading';



const ClientsFeedback = () => {
    const [feeds, setFeeds] = useState([]);

    useEffect(() => {
        fetch('https://secret-eyrie-95562.herokuapp.com/reviews')
            .then(res => res.json())
            .then(data => setFeeds(data))
    }, [])
    return (
        <section className="feedback-container mt-5 mb-5 p-1" id="review">
            <h3 className="text-center">Clients <span style={{ color: '#7ab259' }}>Feedback</span> </h3>
            <div className="container">
                <div className="row mt-5 pt-5">
                    {
                        feeds.length === 0 && <Loading />
                    }
                    {
                        feeds.map(feed => <FeedbackCard feed={feed} key={feed.id}></FeedbackCard>)
                    }
                </div>
            </div>

        </section>
    );
};

export default ClientsFeedback;